"use strict";
import React from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { RX } from '../authentication/constants';

const initComponent = (flex = window.flex) => {

    class SSOPortal extends React.PureComponent {

        constructor(props) {
            super(props);
        }

        handleRedirect = (identityProvider) => {
            return () => {
                flex.trigger(RX.RUN_AUTHORIZATION_CODE_FLOW, { adaptor: identityProvider.domain });
            }
        }

        render() {
            const { identityProviders = [], app: { summary } } = this.props.appContext;
            return (
                <div>
                    <section className="container" role="main">
                        <div className="row">
                            <ListGroup componentClass="ul">
                                {!identityProviders.length && <span>No identity providers exist for {summary}</span>}
                                {identityProviders.length > 0 && identityProviders.map((identityProvider, idx) => (
                                    <ListGroupItem key={idx}
                                        active={identityProvider.default}
                                        onClick={this.handleRedirect(identityProvider)}
                                        header={identityProvider.name}
                                    />
                                ))}
                            </ListGroup>
                        </div>
                    </section>
                </div>
            );
        }
    }

    return SSOPortal;
}

module.exports = initComponent;